import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;



export const WelcomeSection = styled.div`
  background: ${({ theme }) => theme.tokens.color.background.primary};
  border-radius: 1.5rem;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
`;

export const MainGrid = styled.div`
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  margin-bottom: 2rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const UserInfoCard = styled.div`
  background: ${({ theme }) => theme.tokens.color.background.primary};
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  height: fit-content;
`;

export const UserInfoHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
`;

export const UserInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const InfoLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

export const InfoValue = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.tokens.color.text.primary};
  word-break: break-word;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

export const RadarSection = styled.div`
  background: ${({ theme }) => theme.tokens.color.background.primary};
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
`;

export const TableContainer = styled.div`
  border-radius: 1rem;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  background-color: ${({ theme }) => theme.tokens.color.background.primary};
  max-height: 400px;
  overflow-y: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  
  th, td {
    padding: 1rem 1.5rem;
    text-align: left;
    border-bottom: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
    font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }
  
  th {
    background-color: ${({ theme }) => theme.tokens.color.background.primary};
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  tbody tr {
    transition: background-color 0.2s ease;
  }
  
  tbody tr:hover {
    background-color: ${({ theme }) => theme.tokens.color.background.secondary};
  }
  
  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const ActionsSection = styled.div`
  background: ${({ theme }) => theme.tokens.color.background.primary};
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
`;

export const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const ActionCard = styled.div`
  background: ${({ theme }) => theme.tokens.color.background.primary};
  border-radius: 1rem;
  padding: 1.5rem;
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    border-color: ${({ theme }) => theme.tokens.color.border.primary};
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 1rem;
  margin: 1rem 0;
`;

export const EmptyMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const StatCard = styled.div`
  background: ${({ theme }) => theme.tokens.color.background.primary};
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  text-align: center;
`;

export const StatValue = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.tokens.color.text.primary};
  margin-bottom: 0.5rem;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

export const StatLabel = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  font-weight: 500;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-height: 200px;
  padding: 1.5rem;
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  border-radius: 1rem;
  gap: 1rem;
`;

export const Grid = styled.div`
  gap: 1rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
`;
